import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bftwxtye3z: FaireBrandEntity = {
  token: "b_bftwxtye3z",
  type: "brand",
  name: "Ginger And Thread",
  avatarUrl:
    "https://cdn.faire.com/fastly/a6d9ebfa62f1179f6563edfa27e0974cfdb0e1ee201eb2d4e30858a6fb598d90.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9af02ed7bc4e50e2696ccde6a90a13d47d467ccec2611b890bda095c69267948.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a6d9ebfa62f1179f6563edfa27e0974cfdb0e1ee201eb2d4e30858a6fb598d90.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9af02ed7bc4e50e2696ccde6a90a13d47d467ccec2611b890bda095c69267948.png",
  location: "University Place, WA, USA",
  minimumOrderDollars: 173,
  rating: 5,
  reviewCount: 10,
  isInsider: true,
  description:
    "Not everyone's journey to Parenthood is a straight easy downhill road. Some of our paths have twists and turns, potholes, road closures and reroutes. I am one of those Mamas.\n\nI named my Shop Ginger & Babe, before the babe, when the babe was 'surely' just around the corner. I was making baby cloths years before the baby. Soon my Esty shop became a financial resource as we embarked on an expensive and slow journey of infertility treatments. Through uncertain times, without answers, we trudged along. After other options had been exhausted, as a last resort, we proceeded with IVF.\n\nToday we have Charlie. Our Son, our IVF miracle baby. The light of our lives. Then came Cora, a glorious surprise.  \n\nNot everyone's path to parenthood is a straight easy downhill journey, some of us took the roads less traveled. I create for the Mama's who spent years holding out one last hope, the family who experienced great grief from loss. I sew for the Dads who relied on surrogacy. For the Parents who have the joy of adoption. I design for every family who refused to give up. I see you. This is for you. I hope my shop, my creations can be a tiny piece of the beauty and light after the storm.\n\nWith the largest of virtual hugs.\n- Kristin & Charlie aka ---- Ginger & Babe",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:20.176Z",
    importedBy: "entity-db-cli",
  },
};
